import { registerFirestoreDocumentConverter } from "@/firestore/myFreeReads"
import { dexieFirestoreDocument, FirestoreDocument } from "@/types/firestoreDocument"
import { Timestamp } from "firebase/firestore"
import { z } from "zod"

const vacationPeriodSchema = z.object({
   name: z.string().min(1, "Le nom est requis"),
   start_date: z.date({
      errorMap: (issue) => {
         if (issue.code === "invalid_date") {
            return { message: "La date de début est invalide" }
         }
         return { message: "La date de début est requise" }
      },
   }),
   end_date: z.date({
      errorMap: (issue) => {
         if (issue.code === "invalid_date") {
            return { message: "La date de fin est invalide" }
         }
         return { message: "La date de fin est requise" }
      },
   }),
})

export const schoolYearSchema = z.object({
   name: z.string().min(1, "Le nom est requis"),
   start_date: z.date({
      errorMap: (issue) => {
         if (issue.code === "invalid_date") {
            return { message: "La date de début est invalide" }
         }
         return { message: "La date de début est requise" }
      },
   }),
   end_date: z.date({
      errorMap: (issue) => {
         if (issue.code === "invalid_date") {
            return { message: "La date de fin est invalide" }
         }
         return { message: "La date de fin est requise" }
      },
   }),
   vacation_periods: z.array(vacationPeriodSchema),
   created_at: z.date().optional(),
   updated_at: z.date().optional(),
})

export type VacationPeriod = z.infer<typeof vacationPeriodSchema>
export type SchoolYear = z.infer<typeof schoolYearSchema> & FirestoreDocument

export const collectionName = "school_years"

export const dexieSchoolYear = dexieFirestoreDocument + ", vacation_periods"

export const init = () =>
   registerFirestoreDocumentConverter<SchoolYear>(collectionName, (data) => {
      const { start_date, end_date, vacation_periods, ...rest } = data
      return {
         ...rest,
         start_date: (start_date as any as Timestamp)?.toDate(),
         end_date: (end_date as any as Timestamp)?.toDate(),
         vacation_periods: vacation_periods?.map((period: any) => ({
            ...period,
            start_date: (period.start_date as any as Timestamp)?.toDate(),
            end_date: (period.end_date as any as Timestamp)?.toDate(),
         })),
      }
   })
